<template>
  <div id="layout">
    <!-- 如果是微信浏览不显示的顶部 -->
    <Header
      v-if="!isWeiXin && shouldShowHeader"
      title="金声玉亮"
      :unlogin="unlogin"
    />
    <!-- 如果是微信浏览不显示的顶部 -->
    <!-- 中间 main area -->
    <div
      class="middle"
      :style="getMiddleStyle"
    >
      <router-view :key="$route.fullPath" v-if="$route.name && isLayoutReady" />
    </div>
    <icp-info />
    <!-- 中间 main area -->
    <!-- 底部 tabBar -->
    <the-tabbar class="bottom" :active-page="getActivePage()" />
    <!-- 底部 tabBar -->
  </div>
</template>
<script>
import Vue from "vue";
import { NavBar, Button, Icon, Row, Col, Toast, Dialog } from "vant";
import { islogin, logout } from "@/api/theApi";
import TheTabbar from "@/components/theTabbar.vue";
import Header from "./Header";
import IcpInfo from "@/components/IcpInfo.vue";
Vue.use(Button);
Vue.use(NavBar);
Vue.use(Icon);
Vue.use(Row).use(Col);
Vue.use(Dialog);

import * as sysTools from "../utils/sysTools";
export default {
  components: {
    Header,
    TheTabbar,
    IcpInfo,
  },
  data() {
    return {
      isShowIframe: false,
      active: 0,
      icon: {
        normal: "//img.yzcdn.cn/icon-normal.png",
        active: "//img.yzcdn.cn/icon-active.png",
      },
      unlogin: true,
      isLayoutReady: false,
    };
  },
  computed: {
    theUA() {
      return sysTools.getUA();
    },
    isWeiXin() {
      if (this.theUA.indexOf("micromessenger") !== -1) {
        return true;
      } else {
        return false;
      }
    },
    shouldShowHeader() {
      // 定义不显示Header的页面路径
      if (this.$route && this.$route.path) {
        const hiddenHeaderPaths = [
          "/home", // 首页
          "/login", // 登录页
          "/regLogin", // 注册/登录页
        ];

        // 检查当前路径是否匹配任何隐藏Header的路径
        return !hiddenHeaderPaths.some(
          (path) =>
            this.$route.path === path || this.$route.path.startsWith(path + "/")
        );
      }
      return true;
    },
    getMiddleStyle() {
      // 如果是 /jsyl 路由，不设置高度
      // if (this.$route && this.$route.path === '/jsyl') {
      //   if (!this.isWeiXin && this.shouldShowHeader) {
      //     return { paddingTop: '50px' };
      //   } else {
      //     return {};
      //   }
      // }
      
      // 其他路由的正常逻辑
      if (!this.isWeiXin && this.shouldShowHeader) {
        return { paddingTop: '50px', height: 'calc(100vh - 180px)' };
      } else {
        return { height: 'calc(100vh - 108px)' };
      }
    },
  },
  watch: {
    // 监听路由变化，确保导航栏样式正确
    $route(to, from) {
      this.$nextTick(() => {
        this.ensureHeaderStyles();
      });
    },
  },
  created() {
    this.init();
  },
  mounted() {
    // 确保DOM已经挂载完成
    this.$nextTick(() => {
      this.isLayoutReady = true;
      this.ensureHeaderStyles();
    });
  },
  methods: {
    async init() {
      const isloginRes = await islogin();
      const username = localStorage.getItem("username");
      if (isloginRes.login_status && username) {
        // Toast.loading('已经登陆')
        // const b64u = Base64.encode(username)
        this.unlogin = false;
      } else {
        // localStorage.clear()
        this.unlogin = true;
      }
      if (!isloginRes.login_status && username) {
        this.unlogin = true;

        localStorage.clear();
      }
      if (isloginRes.login_status && !username) {
        this.unlogin = true;

        Toast.fail("您已退出\n请重新登陆");
        logout().then(() => {});
      }
    },
    getActivePage() {
      const path = this.$route.path;
      if (path.includes("/home")) {
        return "home";
      } else if (path.includes("/strategylist")) {
        return "teacher";
      } else if (path.includes("/jsyl") || path.includes("/question")) {
        return "question";
      } else if (path.includes("/user")) {
        return "user";
      }
      return "home";
    },
    ensureHeaderStyles() {
      // 确保Header中的导航栏样式正确
      if (!this.isWeiXin && this.shouldShowHeader) {
        setTimeout(() => {
          const navbar = document.querySelector(".van-nav-bar");
          if (navbar) {
            // 强制重置导航栏样式
            navbar.style.position = "fixed";
            navbar.style.top = "0";
            navbar.style.left = "0";
            navbar.style.right = "0";
            navbar.style.zIndex = "1000";
            navbar.style.width = "100%";

            console.log("导航栏样式已重置:", {
              position: navbar.style.position,
              top: navbar.style.top,
              zIndex: navbar.style.zIndex,
            });
          }
        }, 100);
      }
    },
  },
};
</script>
<style lang="less" scoped>
#layout {
  position: absolute;
  height: 100%;
  width: 100%;
  background: #f5f5f5;
  // display: flex;
  // flex-direction: column;
}
.middle {
  // bottom: 4rem;
  // top: 4rem;
  // height: 15rem;
  // position: absolute;
  width: 100%;
  padding-bottom: 60px;
}
.bottom {
  // bottom: 0;
  // // height:4rem;
  // position: absolute;
  width: 100%;
  // background-color: yellow;
}
</style>
